<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{'TASK_RECORD_CUSTOM_STATISTICS_DIAGRAM_ADD' | translate}}</strong></p>
    <button type="button" class="close" (click)="closeDialog(false)" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]='formGroup' (ngSubmit)="saveStat()" #f="ngForm">
    <div class="modal-body">
      <mat-dialog-content [ngStyle]="{'overflow': 'auto'}">
        <div class="form-group row"
             [ngClass]="{ 'has-danger': hasLocalFieldError('name') || hasFieldError(TaskCustomStatistics.ValidatedField.NAME)}">
          <div class="col-md-4">
            <label class="col-form-label mw-100 form-control-label required-field-label">{{'COMMON_NAME'|translate}}</label>
          </div>
          <div class="col-md-8">
            <div class="mw-100">
              <input type="text" class="form-control" placeholder="{{'COMMON_NAME' | translate}}"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     [ngClass]="{ 'form-control-danger': hasLocalFieldError('name') || hasFieldError(TaskCustomStatistics.ValidatedField.NAME) }"
                     (ngModelChange)="removeFieldError(TaskCustomStatistics.ValidatedField.NAME)"
                     [(ngModel)]="data.model.name"
                     formControlName="name">
              <div class="form-control-feedback" *ngIf="hasLocalFieldError('name')">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
              <div class="form-control-feedback" *ngIf="hasFieldError(TaskCustomStatistics.ValidatedField.NAME)">
                {{getFieldErrorText(TaskCustomStatistics.ValidatedField.NAME)}}
              </div>
            </div>
          </div>
        </div>


        <div class="form-group row"
             [ngClass]="{ 'has-danger': hasLocalFieldError('externalId') || hasFieldError(TaskCustomStatistics.ValidatedField.EXTERNAL_ID)}">
          <div class="col-md-4">
            <label class="col-form-label mw-100 form-control-label"
            [ngClass]="{'required-field-label': data.model.updateInProgress}"
            >{{'COMMON_EXTERNAL_ID'|translate}}</label>
          </div>
          <div class="col-md-8">
            <div class="mw-100">
              <input type="text" class="form-control" placeholder="{{'COMMON_EXTERNAL_ID' | translate}}"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     [ngClass]="{ 'form-control-danger': hasLocalFieldError('externalId') || hasFieldError(TaskCustomStatistics.ValidatedField.EXTERNAL_ID) }"
                     [(ngModel)]="data.model.externalId"
                     (ngModelChange)="removeFieldError(TaskCustomStatistics.ValidatedField.EXTERNAL_ID)"
                     formControlName="externalId">
              <div class="form-control-feedback" *ngIf="hasLocalFieldError('externalId')">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
              <div class="form-control-feedback" *ngIf="hasFieldError(TaskCustomStatistics.ValidatedField.EXTERNAL_ID)">
                {{getFieldErrorText(TaskCustomStatistics.ValidatedField.EXTERNAL_ID)}}
              </div>
            </div>
          </div>
        </div>


      </mat-dialog-content>
    </div>
    <div class="modal-footer justify-content-end">
        <span>
          <button type="button" class="btn btn-outline-primary" (click)="closeDialog(false)">
            {{'COMMON_BUTTON_CANCEL' | translate}}
          </button>
          <button type="submit" class="btn btn-primary ml-1"
                  [ladda]="creationInProgress"
                  [disabled]="creationInProgress">
            {{'COMMON_BUTTON_SAVE' | translate}}
          </button>
        </span>
    </div>
  </form>
</div><!-- /.modal-content -->
